export function ignoreError( error ) {
    // Adding error codes here will blacklist the error (assuming the parent function is called)
    const ignoredErrorCodes = [
        'auth/cancelled-popup-request',
        'auth/popup-closed-by-user'
    ];

    if ( ignoredErrorCodes.indexOf( error.code ) !== -1 ) {
        return true;
    }

    return false;
}

/* Prevents strange security issues by removing some functions in the User object */
export function transformFirebaseUser( user ) {
    if ( user ) {
        const storeUser = {};

        const userProperties = ['uid', 'email', 'isAdmin', 'photoURL', 'providerId',
            'isAnonymous', 'displayName', 'providerData', 'refreshToken', 'emailVerified'];

        userProperties.forEach(prop => {
            if ( prop in user ) {
                storeUser[ prop ] = user[ prop ];
            }
        });

        return storeUser;
    }

    return false;
}

export function capitalizeString( str ) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function copyToClipboard( elem ) {
    // create hidden text element, if it doesn't already exist
    var targetId = '_hiddenCopyText_';
    var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
    var origSelectionEnd, origSelectionStart, target;

    if (isInput) {
        // can just use the original source element for the selection and copy
        target = elem;
        origSelectionStart = elem.selectionStart;
        origSelectionEnd = elem.selectionEnd;
    } else {
        // must use a temporary form element for the selection and copy
        target = document.getElementById(targetId);
        if (!target) {
            target = document.createElement('textarea');
            target.style.position = 'absolute';
            target.style.left = '-9999px';
            target.style.top = '0';
            target.id = targetId;
            document.body.appendChild(target);
        }
        target.textContent = elem.textContent;
    }

    // select the content
    var currentFocus = document.activeElement;

    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed;

    try {
        succeed = document.execCommand('copy');
    } catch (e) {
        succeed = false;
    }

    // restore original focus
    if (currentFocus && typeof currentFocus.focus === 'function') {
        currentFocus.focus();
    }

    if (isInput) {
        // restore prior selection
        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
        // clear temporary content
        target.textContent = '';
    }

    return succeed;
}

export function setTitle( title ) {
    document.title = `${ title } — NextGen Climate` || document.title;
}

export function resetTitle() {
    document.title = 'NextGen Climate';
}

export default {
    ignoreError, transformFirebaseUser,
    capitalizeString, copyToClipboard, setTitle, resetTitle
}



// WEBPACK FOOTER //
// ./src/library/util.js